"use client"
import ContentOne from '@/components/modules/ContentOne'
import { BlockType } from '@/libs/types'
import clsx from 'clsx'
import React from 'react'
import { Tab, Tabs } from 'react-bootstrap'

const TabCustomized: React.FC<{ blocks: BlockType[], locale: string }> = ({ blocks = [], locale }) => {
    return (
        <Tabs defaultActiveKey={0} id="uncontrolled-tab" className="justify-content-center" transition={false}>
            {blocks.map((item: any, index: number) => {
                if (item.blocks && item.blocks.length === 0) return null
                return (
                    <Tab eventKey={index} title={item.title} key={index} transition={false}>
                        <div className={clsx('py-5', item.classes)}>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-11 col-12">
                                        <div className="row">
                                            {item.blocks.map((item: any, index: number) => {
                                                return (
                                                    <div className={clsx(`col-md-${item.cols}`, "col-12")} key={index}>
                                                        <div className={clsx(item.classes)}>
                                                            <ContentOne locale={locale} variant="h2" block={item} />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                )
            })}
        </Tabs>
    )
}

export default TabCustomized